// Visual language shared with the public PDP audit page
// (src/pages/publicPdpAudit/PdpAuditPage.tsx) so the wizard reads as the
// same product when embedded on the marketing site or shown in a Dialog.
//
// Brand-facing colors are expressed as CSS custom properties with the TDC
// hex as fallback: outside an RMN wrapper (which sets --rmn-*) every page
// renders pixel-identical to the literal values; inside /portal/:brandSlug the
// tools pick up the white-label palette automatically.
//
// IMPORTANT: these var(...) strings are for DOM styles only. Anything that
// needs a literal hex (@react-pdf styles, canvas, color math) must use
// DEFAULT_TOOL_PALETTE below.
export const GOLD = "var(--rmn-primary, #C8A97E)";
export const GOLD_DARK = "var(--rmn-primary-dark, #A58450)";
export const GOLD_TINT = "var(--rmn-primary-tint, var(--tool-tint, #FAF5ED))";
export const PAGE_BG = "var(--rmn-bg, var(--tool-page, #FAFAF8))";
// Lighter companion used as the loading-bar gradient end; falls back to the
// TDC light gold, resolves to the brand primary (flat bar) under RMN theming.
export const GOLD_LIGHT = "var(--rmn-primary, #D4B98E)";
// Neutral roles: the literal is the light/public value; the --tool-* property
// exists only under [data-theme="dark"] (src/theme/tokens.ts) and maps the
// role onto the portal's real token there.
export const BLACK = "var(--tool-text, #1C1A17)";
export const TEXT_MUTED = "var(--tool-text-2, #7A7268)";
export const TEXT_FAINT = "var(--tool-muted, #9B958C)";
export const TEXT_DISCLAIMER = "var(--tool-muted, #B5AFA5)";
export const BORDER = "var(--tool-border, #E5E1DB)";
export const CARD_BG = "var(--tool-card, #FFFFFF)";
export const SURFACE_2 = "var(--tool-surface-2, #EDEAE5)";
// Disabled primary-button plate.
export const DISABLED_BG = "var(--tool-muted, #CFCAC2)";
// "Ink" buttons: dark plate + white label in light, inverted in dark.
export const INK_BG = "var(--tool-ink, #1C1A17)";
export const INK_TEXT = "var(--tool-ink-text, #FFFFFF)";
export const GREEN = "var(--tool-up, #5A9E6F)";
export const GREEN_BG = "var(--tool-up-bg, #E8F5E9)";
export const RED = "var(--tool-down, #c62828)";
export const RED_BG = "var(--tool-down-bg, #FBEFEF)";
export const FONT = "'DM Sans', sans-serif";

// Literal TDC hexes for non-CSS consumers (@react-pdf, canvas, color math).
// Keep in sync with the var() fallbacks (light values) above.
export const DEFAULT_TOOL_PALETTE = {
    GOLD: "#C8A97E",
    GOLD_DARK: "#A58450",
    GOLD_TINT: "#FAF5ED",
    GOLD_LIGHT: "#D4B98E",
    PAGE_BG: "#FAFAF8",
    BLACK: "#1C1A17",
    TEXT_MUTED: "#7A7268",
    TEXT_FAINT: "#9B958C",
    BORDER: "#E5E1DB",
    CARD_BG: "#FFFFFF",
    GREEN: "#5A9E6F"
} as const;
